import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { client } from '../lib/sanity';
import { getPetUrlPath } from '../lib/petUtils';

export function SanityStructureRedirect() {
  const { structureType, id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const redirectToContent = async () => {
      if (!id) {
        navigate('/');
        return;
      }

      try {
        // Obsługa różnych typów struktur
        switch (structureType) {
          case 'pet': {
            const pet = await client.fetch(
              `*[_type == "pet" && _id == $id && !(_id in path("drafts.**"))][0] {
                slug,
                _id,
                name
              }`,
              { id }
            );

            if (pet) {
              navigate(getPetUrlPath(pet), { replace: true });
            } else {
              navigate('/zwierzeta', { replace: true });
            }
            break;
          }

          case 'post': {
            const post = await client.fetch(
              `*[_type == "post" && _id == $id && !(_id in path("drafts.**"))][0] {
                slug,
                _id
              }`,
              { id }
            );

            if (post?.slug) {
              navigate(`/aktualnosci/${post.slug.current}`, { replace: true });
            } else {
              navigate('/aktualnosci', { replace: true });
            }
            break;
          }

          case 'successStory':
            navigate('/historie-adopcyjne', { replace: true });
            break;

          case 'financialReport':
            navigate('/sprawozdania', { replace: true });
            break;

          case 'petTag':
          case 'author':
          case 'category':
          case 'monthlyGoal':
          case 'videoEmbed':
          case 'blockContent':
            // Pomocnicze struktury bez osobnych stron - przekieruj do strony zwierząt lub głównej
            navigate('/zwierzeta', { replace: true });
            break;

          default:
            // Dla nieobsługiwanych typów, przekieruj na główną
            navigate('/', { replace: true });
            break;
        }
      } catch (error) {
        console.error('Error redirecting structure:', error);
        navigate('/', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    redirectToContent();
  }, [structureType, id, navigate]);

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-16">
        <p className="text-center text-xl text-accessible-gray-600 dark:text-accessible-gray-300">
          Przekierowywanie...
        </p>
      </div>
    );
  }

  return null;
}

